import {AbstractAdminEntityService} from "../../admin/AbstractAdminEntityService";
import {AdminEntityService} from "../../admin/AdminEntityService";
import {LeaderboardConfig, ListLeaderboardResponse} from "../../../../generated/protocol";
import {injectable} from "inversify";

export const LEADERBOARD_COUNTER_SERVICE_NAME = "leaderboardCounterService";

export interface LeaderboardCounterService extends AdminEntityService<LeaderboardConfig> {

}

@injectable()
export class LeaderboardCounterServiceImpl extends AbstractAdminEntityService<LeaderboardConfig, ListLeaderboardResponse> implements LeaderboardCounterService {

    constructor() {
        super("/leaderboards/counter");
    }


}


// WEBPACK FOOTER //
// ./src/app/service/poker/leaderboard/LeaderboardCounterService.ts